import React, { useState, useEffect } from "react";
import "./UserProfile.css";
import ProfileInfo from "../ProfileInfo/ProfileInfo";
import Cookies from "js-cookie";
import { SpinnerLoading } from "../../../../components";
import "react-phone-number-input/style.css";
import { toast } from "react-toastify";
import profileImageUrl from "../../../../assets/images/profile/Mask group.png";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { useTranslation } from "../../../../contexts/TranslationContext";
import { TextField, Autocomplete } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";

import { axiosGet, axiosPost } from "../../../../utils/apis/api";

const UserProfile = ({ url }) => {
  const Lang = Cookies.get("preferred_language") || "en";
  const PAGE_LIMIT = 50;
  const { t } = useTranslation();

  const [countries, setCountries] = useState([]);
  const [countryInputValue, setCountryInputValue] = useState("");
  const [selectedNationality, setSelectedNationality] = useState(null);
  const [selectedBirthCountry, setSelectedBirthCountry] = useState(null);
  const [maritalStatus, setMaritalStatus] = useState("");
  const [birthCountryInputValue, setBirthCountryInputValue] = useState("");
  const maritalStatusOptions = [
    { value: "Single", label: t("Single") },
    { value: "Married", label: t("Married") },
    { value: "Divorced", label: t("Divorced") },
    { value: "Widowed", label: t("Widowed") },
    { value: "Separated", label: t("Separated") },
    { value: "Engaged", label: t("Engaged") },
    { value: "In a Relationship", label: t("InRelationship") },
    { value: "Other", label: t("Other") },
  ];
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    if (
      selectedNationality?.location_name &&
      selectedBirthCountry?.location_name &&
      maritalStatus
    ) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [selectedNationality, selectedBirthCountry, maritalStatus]);
  const [hasMoreCountries, setHasMoreCountries] = useState(true);
  const fetchCountries = async (search = "", start = 0, append = false) => {
    if (!hasMoreCountries && append) return;
    try {
      const response = await axiosGet(
        `${url}/api/method/alltimes.www.api.locations`,
        {
          search,
          start,
          limit: PAGE_LIMIT,
          location_type: "Country",
        }
      );

      const newItems = response.result?.locations || [];
      setCountries((prev) => (append ? [...prev, ...newItems] : newItems));
      setHasMoreCountries(newItems.length === PAGE_LIMIT);
    } catch (err) {
      console.error("Country fetch error:", err);
      setCountries([]);
    }
  };
  useEffect(() => {
    if (countries.length > 0 && countryInputValue) {
      const match = countries.find(
        (c) =>
          c.location_name?.toLowerCase() === countryInputValue.toLowerCase()
      );
      if (match) {
        setSelectedNationality(match);
      }
    }
  }, [countries, countryInputValue]);

  const [profilePhotoUrl, setProfilePhotoUrl] = useState();
  const [baseProfilePhotoUrl, setBaseProfilePhotoUrl] = useState(profileImageUrl);
  const [selectedPhotoFile, setSelectedPhotoFile] = useState(null);
  const initialUserImage = Cookies.get("user_image") || null;
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);


  const fetchUserProfile = async () => {
    try {
      setIsLoading(true);
      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");

      const res = await fetch(
        `${url}/api/method/alltimes.www.api.get_user_profile`,
        {
          method: "POST",
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `token ${apiKey}:${apiSecret}`,
          },
        }
      );


      if (!res.ok) {
        toast.error(t("ErrorConnectingToTheServer") + res.status);
        return;
      }

      const result = await res.json();

      if (Array.isArray(result.message) && result.message.length > 0) {
        const user = result.message[0];
        if (user.email === "guest@example.com") {
          toast.warn(t("UserNotRecognizedPleaseLogIn"));
        }
        setFirstName(user.full_name_as_passport?.split(" ")[0] || "");
        setLastName(user.full_name_as_passport?.split(" ")[1] || "");
        setEmail(user.email || "");
        setPhoneNumber(user.mobile_no || "");
        setSelectedPhotoFile(null);
        if (user.user_image) {
          const fullImageUrl = `${url}${user.user_image}`;
          setProfilePhotoUrl(fullImageUrl);
          setBaseProfilePhotoUrl(user.user_image);
        }
        const userNationality = user.nationality;
        if (userNationality) {
          setCountryInputValue(userNationality); // For text input display

          // Try to find matching country from already fetched list
          const match = countries.find(
            (c) =>
              c.location_name?.toLowerCase() === userNationality.toLowerCase()
          );

          if (match) {
            setSelectedNationality(match);
          } else {
            // If not found, fetch countries with the nationality as a search term
            fetchCountries(userNationality).then(() => {
              setSelectedNationality((prev) =>
                countries.find(
                  (c) =>
                    c.location_name?.toLowerCase() ===
                    userNationality.toLowerCase()
                )
              );
            });
          }
        }

        if (user.country_of_birth) {
          const birthCountryObj = { location_name: user.country_of_birth };
          setSelectedBirthCountry(birthCountryObj);
          setBirthCountryInputValue(user.country_of_birth);
        }

        if (user.marital_status) {
          setMaritalStatus(user.marital_status);
        }
      } else {
        toast.error(t("WeCouldn'tFetchTheUserData"));
      }
    } catch (error) {
      console.error("fetchUserProfile error:", error);
      toast.error(t("AnErrorOccurredWhileFetchingTheData"));
    } finally {
      setIsLoading(false);
    }
    
    
  };

  const updateUserProfile = async (image) => {
    const formData = new FormData();

    formData.append("full_name_as_passport", `${firstname} ${lastname}`);
    formData.append("email", email);
    formData.append("mobile_no", phoneNumber);
    formData.append("nationality", selectedNationality?.location_name || "");
    formData.append("country_of_birth", selectedBirthCountry?.location_name || "");
    formData.append("marital_status", maritalStatus || "Single");

    // if (selectedNationality?.location_name) {
    //   formData.append("nationality", selectedNationality.location_name);
    // }

    // if (selectedBirthCountry?.location_name) {
    //   formData.append("country_of_birth", selectedBirthCountry.location_name);
    // }

    // if (maritalStatus) {
    //   formData.append("marital_status", maritalStatus);
    // }

    if (image) {
      formData.append("user_image", image);
    }

    try {
      const res = await fetch(
        `${url}/api/method/alltimes.www.api.update_user_profile`,
        {
          method: "POST",
          headers: {
            Authorization: `token ${Cookies.get("api_key")}:${Cookies.get(
              "api_secret"
            )}`,
          },
          body: formData,
        }
      );

      const data = await res.json();

      if (data.message) {
        setSelectedPhotoFile(null);
        toast.success(t("Profileupdatedsuccessfully"));
        fetchUserProfile();
      } else {
        toast.error(t("FailedToUpdateProfile"));
      }
    } catch (err) {
      console.error("Update error:", err);
      toast.error(t("AnErrorOccurredWhileUpdatingProfile"));
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);

  try {
    let uploadedPhotoUrl = null;
    console.log(selectedPhotoFile)
    if (selectedPhotoFile) {
      // Upload profile photo first
      uploadedPhotoUrl = await uploadProfilePhoto(selectedPhotoFile);
      setProfilePhotoUrl(uploadedPhotoUrl);
    }
    await updateUserProfile(uploadedPhotoUrl?? baseProfilePhotoUrl);
    
    console.log("Profile updated successfully!");
  } catch (error) {
    console.error("Error updating profile:", error);
  } finally {
    setIsLoading(false);
  }
};


  useEffect(() => {
    fetchUserProfile();
  }, []);

  const handleChangePhone = (value) => {
    setPhoneNumber(value);
  };


  const handleCancel = () => {
    // setFirstName("");
    // setLastName("");
    // setEmail("");
    // setPhoneNumber("");
    // setCurrentPassword("");
    // setNewPassword("");
    // setConfirmPassword("");
  };

const handlePhotoChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  setSelectedPhotoFile(file);

  // Show preview
  const imageUrl = URL.createObjectURL(file);
  setProfilePhotoUrl(imageUrl);

};

// Upload function without progress
const uploadProfilePhoto = async (file) => {
  const apiKey = Cookies.get("api_key");
  const apiSecret = Cookies.get("api_secret");

  const fd = new FormData();
  fd.append("file", file);

  try {
    const response = await axios.post(
      "https://crm.alltimestravels.com/api/method/upload_file",
      fd,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `token ${apiKey}:${apiSecret}`,
        },
      }
    );

    // Return the file URL from response
    return response.data?.message?.file_url || "";
  } catch (error) {
    console.error("Error uploading photo:", error);
    return "";
  }
};



  return isLoading ? (
  <div className="loading-container">
    <SpinnerLoading />
  </div>
  ) : (
    <div className="">
      <ProfileInfo
          onPhotoChange={handlePhotoChange}
          name={`${firstname} ${lastname}`}
          email={email}
          ProfilePhoto={profilePhotoUrl?? profileImageUrl}
          photoName={t("ProfilePhoto")}
        />
      <div className="">
        <div className="-tab profile-form2">
          <div className="personal-info-row">
            <div className="user-edit">
              <span className="tab-photo">{t("EditProfile")}</span>
            </div>
            <div className="personal-info">{t("PersonalInformation")}</div>
            <form className="row new-profile-form ">
              <div className="col-lg-3 top-label">
                <div className="form-group">
                  <label className="profile-label" htmlFor="tbFirstName">
                    {t("FirstName")}
                  </label>
                  <input
                    type="text"
                    className="form-control profile-form-input"
                    placeholder={t("FirstName")}
                    value={firstname}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-lg-3 top-label">
                <div className="form-group">
                  <label className="profile-label" htmlFor="tbLastName">
                    {t("LastName")}
                  </label>
                  <input
                    type="text"
                    className="form-control profile-form-input"
                    placeholder={t("LastName")}
                    value={lastname}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-lg-3 top-label">
                <div className="form-group">
                  <label className="profile-label" htmlFor="tbEmail">
                    {t("Email")}
                  </label>
                  <input
                    type="email"
                    className="form-control profile-form-input"
                    placeholder={t("Email")}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-lg-3 top-label">
                <div className="form-group">
                  <label className="profile-label" htmlFor="tbEmail">
                    {t("PhoneNumber")}
                  </label>
                  <PhoneInput
                    placeholder="Enter phone number"
                    value={phoneNumber}
                    onChange={handleChangePhone}
                    country="US"
                    defaultCountry={"US"}
                    international
                    className="contact-input-text"
                    disabled={isLoading}
                    required
                  />
                </div>
              </div>

              <div className="col-lg-3 top-label">
                <div className="hotel-form-input-container">
                  <label className="hotel-form-input-label">
                    {t("Nationality")}
                    <span>*</span>
                  </label>
                  <Autocomplete
                    dir={Lang === "ar" ? "rtl" : "ltr"}
                    style={{ width: "100%" }}
                    options={countries || []}
                    value={selectedNationality}
                    onChange={(event, newValue) => {
                      setSelectedNationality(newValue);
                      setCountryInputValue(newValue?.location_name || "");
                    }}
                    getOptionLabel={(option) => option?.location_name || ""}
                    inputValue={countryInputValue}
                    onInputChange={(event, newInputValue, reason) => {
                      if (reason !== "reset") {
                        setCountryInputValue(newInputValue);
                        fetchCountries(newInputValue);
                      }
                    }}
                    onFocus={() => {
                      fetchCountries();
                    }}
                    sx={{
                      ".MuiAutocomplete-inputRoot": {
                        fontSize: "12px",
                        flexDirection: Lang === "ar" ? "row-reverse" : "row",
                      },
                      ".MuiAutocomplete-endAdornment": {
                        left:
                          Lang === "ar" ? "9 !important" : "unset !important",
                        right:
                          Lang === "ar" ? "unset !important" : "9 !important",
                      },
                      ".MuiInputBase-input": {
                        textAlign: Lang === "ar" ? "right" : "left",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        placeholder={t("Nationality")}
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            direction: Lang === "ar" ? "rtl" : "ltr",
                          },
                          sx: {
                            backgroundColor: "#FFF",
                            borderRadius: "6px",
                            padding: "9px 15px !important",
                            fontFamily: '"Dmsans400"',
                            fontSize: "13px !important",
                            fontWeight: 400,
                            letterSpacing: "0.25px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option.name}>
                        {option.location_name}
                      </li>
                    )}
                  />
                    {!selectedNationality?.location_name && (
                      <span className="invalid-feedback">{t("NationalityIsRequired")}</span>
                    )}
                </div>
              </div>

              <div className="col-lg-3 top-label">
                <div className="hotel-form-input-container">
                  <label className="hotel-form-input-label">
                    {t("CountryOfBirth")}
                    <span>*</span>
                  </label>
                  <Autocomplete
                    dir={Lang === "ar" ? "rtl" : "ltr"}
                    style={{ width: "100%" }}
                    options={countries || []}
                    value={selectedBirthCountry}
                    onChange={(event, newValue) => {
                      setSelectedBirthCountry(newValue);
                      setBirthCountryInputValue(newValue?.location_name || "");
                    }}
                    getOptionLabel={(option) => option?.location_name || ""}
                    inputValue={birthCountryInputValue}
                    onInputChange={(event, newInputValue, reason) => {
                      if (reason !== "reset") {
                        setBirthCountryInputValue(newInputValue);
                        fetchCountries(newInputValue);
                      }
                    }}
                    onFocus={() => {
                      fetchCountries();
                    }}
                    sx={{
                      ".MuiAutocomplete-inputRoot": {
                        fontSize: "12px",
                        flexDirection: Lang === "ar" ? "row-reverse" : "row",
                      },
                      ".MuiAutocomplete-endAdornment": {
                        left:
                          Lang === "ar" ? "9 !important" : "unset !important",
                        right:
                          Lang === "ar" ? "unset !important" : "9 !important",
                      },
                      ".MuiInputBase-input": {
                        textAlign: Lang === "ar" ? "right" : "left",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        placeholder={t("CountryOfBirth")}
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            direction: Lang === "ar" ? "rtl" : "ltr",
                          },
                          sx: {
                            backgroundColor: "#FFF",
                            borderRadius: "6px",
                            padding: "9px 15px !important",
                            fontFamily: '"Dmsans400"',
                            fontSize: "13px !important",
                            fontWeight: 400,
                            letterSpacing: "0.25px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option.name}>
                        {option.location_name}
                      </li>
                    )}
                  />
                    {!selectedBirthCountry?.location_name && (
                      <span className="invalid-feedback">{t("CountryOfBrthIsRequired")}</span>
                    )}
                </div>
              </div>

              <div className="col-lg-3 top-label">
                <div className="hotel-form-input-container">
                  <label className="hotel-form-input-label">
                    {t("MaritalStatus")}
                    <span>*</span>
                  </label>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    value={maritalStatus}
                    onChange={(e) => setMaritalStatus(e.target.value)}
                    InputProps={{
                      style: {
                        direction: Lang === "ar" ? "rtl" : "ltr",
                      },
                      sx: {
                        backgroundColor: "#FFF",
                        borderRadius: "6px",
                        padding: "3px 15px !important",
                        fontFamily: '"Dmsans400"',
                        fontSize: "13px !important",
                        fontWeight: 400,
                        letterSpacing: "0.25px",
                        "& svg": {
                          right: Lang === "ar" ? "unset" : "7px",
                          left: Lang === "ar" ? "20px" : "unset",
                          position: "absolute",
                        },
                      },
                    }}
                  >
                    {maritalStatusOptions.map((option) => (
                      <MenuItem
                        className="menu-marital-status"
                        key={option.value}
                        value={option.value}
                        style={{ direction: Lang === "ar" ? "rtl" : "ltr" }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                    {!maritalStatus && (
                      <span className="invalid-feedback">{t("MaritalStatusIsRequired")}</span>
                    )}
                </div>
              </div>

              <div className="button-container">
                <div className="edit-user-btn-container">
                  {/* <button className="btn-reset"
                  //  onClick={handleCancel}
                   >
                    {t("Reset")}
                  </button> */}
                  <button
                      onClick={handleSubmit}
                      disabled={!isFormValid || isLoading}
                      className={`btn-save ${!isFormValid || isLoading ? "disabled" : ""}`}
                    // className="btn-save"
                    style={{ paddingLeft: "30px", cursor: "pointer" }}
                    // disabled={isLoading}
                  >
                    {t("Save")}
                  </button>
                </div>
              </div>
            </form>
          </div>

          {/* <div className="personal-info"> {t("SecurityInformation")}</div>
          <form className="row new-profile-form">
            <div className="col-lg-4 top-label">
              <div className="form-group">
                <label className="profile-label" htmlFor="tbLastName">
                  {t("CurrentPassword")}
                </label>
                <input
                  type="password"
                  className="form-control profile-form-input"
                  placeholder={t("CurrentPasswordPlaceholder")}
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                />
              </div>
            </div>

            <div className="col-lg-4 top-label">
              <div className="form-group">
                <label className="profile-label" htmlFor="tbFirstName">
                  {t("NewPassword")}
                </label>
                <input
                  type="password"
                  className="form-control profile-form-input"
                  placeholder={t("NewPasswordPlaceholder")}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  disabled
                />
              </div>
            </div>
            <div className="col-lg-4 top-label">
              <div className="form-group">
                <label className="profile-label" htmlFor="tbEmail">
                  {t("ConfirmPassword")}
                </label>
                <input
                  type="password"
                  className="form-control profile-form-input"
                  placeholder={t("ConfirmPasswordPlaceholder")}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  disabled
                />
              </div>
            </div>
          </form> */}
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
